import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.6/js/helpers-sparta";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import radioButton from "utilities/helpers/helpers-radio-button/4.3.5/js/helpers-radio-button";
import * as dep from "modules/login/ah-caw-dp-module/6.3.0/js/dep";
import ahCawDpController from "modules/login/ah-caw-dp-module/6.3.0/js/ah-caw-dp-controller";
import ahCawDpView from "modules/login/ah-caw-dp-module/6.3.0/js/ah-caw-dp-view";
import ahCawDpModel from "modules/login/ah-caw-dp-module/6.3.0/js/ah-caw-dp-model";
import spartaTemplates from "modules/login/ah-caw-dp-module/6.3.0/js/templates";
import "css!modules/login/ah-caw-dp-module/6.3.0/css/ah-caw-dp-module.scss.css";









export default class ahCawDpModuleJS extends Module {
  constructor(options) {
    super(options);

    this._debug('ahDevicePreferncesModule Instantiated with options:', options);

    this.apiEndPoints = {};
		this.endpoints = options.endpoints;




    const basePath = ahCawCommons.getBasePath(this.spaParams);
    this.apiEndPoints = ahCawCommons.getEndPoints(options.endpoints, basePath);
  }

  init(args = {}) {
	    this.$moduleContext = $(this.settings.target);
	    this.Events.sub(cawEventsMasterUtility.EVENTS.SHOW_DEVICE_PREF, (e) => {
	    	  console.log('Device Pref module instantiated');
	    });

	    Object.assign(this.view, new ahCawDpView(this));
	    Object.assign(this.model, new ahCawDpModel(this));
	    Object.assign(this.controller, new ahCawDpController(this));

	    this.view._initialize();
	    this.model._initialize();
	    this.controller._initialize();
  }
}
